import { useContext } from 'react';

import { PaymentInputContext } from './context';

export const usePaymentInputContext = () => {
  const context = useContext(PaymentInputContext);

  if (context === undefined) {
    throw new Error('usePaymentInputContext() must be used within PaymentInputContext.Provider');
  }

  return context;
};

export { PaymentInputContextProvider } from './Provider';
